'use strict';

const Analytics = require('./analytics');

function returnFormatedPaymentMethod (method) {
    const refundMethodOptions = {
        'wireTransfer': 'wire_transfer',
        'returnCard': 'e_reso_card',
        'sameCommerceMethod': 'same_payment_method'
    };
    return refundMethodOptions[method];
}

class Refund extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'Refund';
        super.init(globalContainer, helperContainer);
        this.prepareRefundObservers();
        this.itemSkus = [];
        this.doubleRun = false;
    }

    prepareRefundObservers () {
        var _self = this;

        $('body').on('analytics:selectedReturnReason', (_e, data) => {
            _self.itemSkus = [];
            var productLineItems = data.productsInfo.productInfoLineItem;
            for (let i = 0; i < productLineItems.length; i++) {
                let productLineItem = productLineItems[i].returnDataForProduct;
                if (productLineItem.returnReasonId !== '-1') {
                    let refundMotivation = $(`[data-reason-id='${productLineItem.returnReasonId}']`).data('analytics-value');
                    if (refundMotivation) {
                        refundMotivation = refundMotivation.toLowerCase().replace(/ /g, '_');
                    }
                    let sku = _self.helper.getFormatSku(productLineItems[i].sku);

                    _self.itemSkus.push(sku);
                    _self.quickImpressionSender.pushRefundOptionMotivationSelect(refundMotivation, sku);
                }
            }
        });

        // Normal refund flow - procceding with payment select
        $('body').on('analytics:selectedReturnMethod', function (_e, data) {
            const shippingMethodOptions = {
                'HOME': 'home',
                'STORE': 'shop',
                'PICKUPPOINT': 'pickup_point'
            };

            _self.quickImpressionSender.pushRefundOptionShippingMethod(
                shippingMethodOptions[data.selectedShippingMethod],
                _self.itemSkus.join('-')
            );
        });

        $('body').on('analytics:selectedRefundMethod', function (_e, data) {
            _self.quickImpressionSender.pushRefundOptionPaymentMethod(
                returnFormatedPaymentMethod(data.selectedRefundMethod),
                _self.itemSkus.join('-')
            );
        });

        $('body').on('analytics:returnConfirmation', function (_e, data) {
            const { orderNo, selectedRefundMethod, selectedShippingMethod } = data;

            _self.quickImpressionSender.pushRefundOptionConfirmation(
                _self.itemSkus.join('-'),
                selectedShippingMethod === 'PICKUPPOINT' ? 'pickup_point' : 'home',
                returnFormatedPaymentMethod(selectedRefundMethod),
                orderNo
            );
            _self.itemSkus = [];
        });

        // Return to store flow - via fake typ || after user selects store
        $('body').on('analytics:returnToStoreConfirmation', function (e) {
            let orderID = $('.js-returnOpen-summarySection .analytics-orderID').text();
            _self.quickImpressionSender.pushRefundOptionConfirmation(_self.itemSkus.join('-'), 'shop', '0', orderID);
            _self.itemSkus = [];
        });

        // 6.33 FIND YOUR STORE & 6.34 FIND YOUR STORE - GEOLOCATION -- For return a product flow
        $('body').on('analytics:refundFindYourStore', function (_e, data) {
            if (data.action === 'geolocation') {
                // to prevent geolocation double triggering
                if (!_self.doubleRun) {
                    // wait the dom to load
                    setTimeout(function () {
                        let location = $($('.cc-findInStoreModal-storeName .store-name').get(0)).text().replaceAll(',', '');
                        _self.quickImpressionSender.pushFindStoreGeolocationImpressionCheckout(
                            _self.helper.formatNameForAnalytics(location),
                            _self.itemSkus.join('-'),
                            'search_for_return',
                            null
                        );
                    }, 1000);
                }
                _self.doubleRun = !_self.doubleRun;
            } else {
                _self.quickImpressionSender.pushFindStoreFindInteraction(
                    data.where,
                    _self.itemSkus.join('-'),
                    'search_for_return',
                    null
                );
            }
        });

        // 6.126 STORE LOCATOR - ACTIONS -- For return a product flow
        $('body').on('analytics:refundStoreActions', function (_e, data) {
            _self.quickImpressionSender.pushFindStoreClickResultAction(
                data.action,
                _self.helper.formatNameForAnalytics(data.store),
                _self.itemSkus.join('-'),
                'search_for_return',
            );
        });
    }
}

const obj = new Refund();
module.exports = obj;
